module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/gallery12-77b8127c4fc299fb4d6b04466370fe97.jpg";